import { Component } from '@angular/core';
import { RedirectService } from '../../services/redirect.service';

@Component({
  selector: 'yi-not-found',
  template: require('./not_found.component.html'),
  styles: [require('./not_found.component.scss')]
})
export class PageNotFoundComponent {

  constructor(redirectService: RedirectService) {
    redirectService.redirectTo(location.pathname);
  }
}
